import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as config from "../../../../constants/config";
import * as navigationActions from "../../../../actions/navigationActions";
import * as statisticsTabActions from "../../../../actions/statisticsTabActions";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as validationHelper from "../../../../helpers/validationHelper";

import Button, {BUTTON_SMALL} from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Modal from "../../../global/generic/Modal";

import imgRetint from "../../../../resources/img/svgicons/retint.svg";

class RetintModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            numberOfPackages: String(this.props.numberOfPackages)
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.numberOfPackages !== prevProps.numberOfPackages) {
            this.setState({numberOfPackages: String(this.props.numberOfPackages)});
        }
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handlePlusClick = () => {
        let numberOfPackages = Number(this.state.numberOfPackages) + 1;

        if (numberOfPackages <= config.MAX_NUMBER_OF_PACKAGES) {
            this.setState({numberOfPackages: String(numberOfPackages)});
            this.props.dispatchSetNumberOfPackagesAction(this.props.tabId, numberOfPackages);
        }
    };

    handleMinusClick = () => {
        let numberOfPackages = Number(this.state.numberOfPackages) - 1;

        if (numberOfPackages > 0) {
            this.setState({numberOfPackages: String(numberOfPackages)});
            this.props.dispatchSetNumberOfPackagesAction(this.props.tabId, numberOfPackages);
        } else {
            this.setState({numberOfPackages: "1"});
            this.props.dispatchSetNumberOfPackagesAction(this.props.tabId, 1);
        }
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    handleInputChange = (event) => {
        if (event.target.value === "") {
            this.setState({numberOfPackages: ""});
        } else if (validationHelper.isIntegerValueValid(event.target.value)) {
            let numberOfPackages = Number(event.target.value);

            if (numberOfPackages > 0 && numberOfPackages < config.MAX_NUMBER_OF_PACKAGES) {
                this.setState({numberOfPackages: event.target.value});
            }
        }
    };

    handleInputBlur = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            if (event.target.value.trim().length === 0 || event.target.value === "0") {
                this.setState({numberOfPackages: "1"});
                this.props.dispatchSetNumberOfPackagesAction(this.props.tabId, 1);
            } else {
                this.setState({numberOfPackages: event.target.value.trim()});
                this.props.dispatchSetNumberOfPackagesAction(this.props.tabId, Number(event.target.value));
            }
        }
    };

    handleRetintClick = () => {
        this.props.dispatchStartRetintAction(this.props.tabId, Number(this.state.numberOfPackages));
    };

    isRetintButtonDisabled = () => {
        if (this.state.numberOfPackages.trim().length === 0) {
            return true;
        }

        return !validationHelper.isIntegerValueValid(this.state.numberOfPackages);
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <div className="flex flex-wrap">
                <div className="col-12 flex margin-top-10">
                    <div className="col-4 bold">
                        <Translate value="general.product" />:
                    </div>
                    <div className="col-8">{this.props.product?.displayName ?? ""}</div>
                </div>
                <div className="col-12 flex margin-top-10">
                    <div className="col-4 bold">
                        <Translate value="general.fandeck" />:
                    </div>
                    <div className="col-8">{this.props.fandeck?.displayName ?? ""}</div>
                </div>
                <div className="col-12 flex margin-top-10">
                    <div className="col-4 bold">
                        <Translate value="general.colorName" />:
                    </div>
                    <div className="col-8">
                        <div className="color-square" style={{backgroundColor: this.props.color?.rgb ?? null}} />
                        {this.props.color?.displayName ?? ""}
                    </div>
                </div>
                <div className="col-12 flex margin-top-10">
                    <div className="col-4 bold">
                        <Translate value="general.base" />:
                    </div>
                    <div className="col-8">{this.props.base?.displayName ?? ""}</div>
                </div>
                <div className="col-12 flex margin-top-10">
                    <div className="col-4 bold">
                        <Translate value="general.package" />:
                    </div>
                    <div className="col-8">{this.props.package?.package?.displayName ?? ""}</div>
                </div>
                <div className="col-12 flex margin-top-5">
                    <div className="col-4 bold margin-top-5">
                        <Translate value="general.numberOfPackages" />:
                    </div>
                    <div className="col-8">
                        <div className="col-12 flex plus-minus-input">
                            <Button
                                size={BUTTON_SMALL}
                                className="color-primary bold"
                                onClick={this.handleMinusClick}
                                label="-"
                            />
                            <input
                                type="text"
                                value={this.state.numberOfPackages}
                                onFocus={this.handleInputFocus}
                                onChange={this.handleInputChange}
                                onBlur={this.handleInputBlur}
                            />
                            <Button
                                size={BUTTON_SMALL}
                                className="color-primary bold"
                                onClick={this.handlePlusClick}
                                label="+"
                            />
                        </div>
                    </div>
                </div>
            </div>,
            "flex-column flex-gap-10px slim-scroll"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <CancelButton onClick={this.handleCloseModalClick} />
                <Button
                    className="margin-right-10"
                    label={<Translate value="general.retint" />}
                    svgBefore={imgRetint}
                    onClick={this.handleRetintClick}
                    elementProps={{"data-robot": "retint-button"}}
                    disabled={this.isRetintButtonDisabled()}
                />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(translate("general.retint"))}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    minWidth: "50%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (ownProps.tabId === undefined || store.formula[ownProps.tabId] === undefined) {
        return {
            loggedUser: store.login.loggedUser,
            product: null,
            fandeck: null,
            color: null,
            base: null,
            package: null,
            numberOfPackages: 1
        };
    }

    return {
        loggedUser: store.login.loggedUser,
        product: store.formula[ownProps.tabId].product,
        fandeck: store.formula[ownProps.tabId].fandeck,
        color: store.formula[ownProps.tabId].color,
        base: store.formula[ownProps.tabId].base,
        package: store.formula[ownProps.tabId].package,
        numberOfPackages: store.formula[ownProps.tabId].numCanTotal
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchStartRetintAction: (tabId, packageCount) => {
            dispatch(statisticsTabActions.startRetint(tabId, packageCount));
        },
        dispatchSetNumberOfPackagesAction: (tabId, packageCount) => {
            dispatch(statisticsTabActions.setNumberOfPackages(tabId, packageCount));
        },
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.RETINT_MODAL));
        }
    };
};

export default RetintModal = connect(mapStoreToProps, mapDispatchToProps)(RetintModal);
